import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=23e8185c&scoped=true"
import script from "./PhotoModal.vue?vue&type=script&lang=js"
export * from "./PhotoModal.vue?vue&type=script&lang=js"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=23e8185c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8185c",
  null
  
)

export default component.exports